import { render, staticRenderFns } from "./address_list.vue?vue&type=template&id=4341a8af&scoped=true&"
import script from "./address_list.vue?vue&type=script&lang=js&"
export * from "./address_list.vue?vue&type=script&lang=js&"
import style0 from "./address_list.vue?vue&type=style&index=0&id=4341a8af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4341a8af",
  null
  
)

export default component.exports